import { Background } from '@fhs/ui';
type AuthHeaderProps = {
  backgroundHeight?: number;
  imageHeight: number;
};

export function AuthHeader({ backgroundHeight, imageHeight }: AuthHeaderProps): React.JSX.Element {
  return <Background backgroundHeight={backgroundHeight} imageHeight={imageHeight} />;
}
